exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".cardNewStyle{border:.5px solid #898989!important}", ""]);

// exports
